import { useGetIdentity } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { TenantHome } from "@/components/tenant/TenantHome";

export const HomePage = () => {
  const navigate = useNavigate();
  const { data: user } = useGetIdentity();

  useEffect(() => {
    if (user && user.tenant === "__root__") {
      navigate("/tenants");
    } else {
      navigate("/instances");
    }
  }, [user, navigate]);
  let content = null;
  if (!user || user.tenant !== "__root__") {
    navigate("/instances");
  }
  return content;
};
